import React from "react";

const LoadAndDisplay = ({
  children,
  isLoading,
  element = "div",
  className,
}) => {
  if (isLoading) {
    const Element = element; // dynamic wrapper

    return (
      <Element
        className={`w-100 mt-4d-flex justify-content-center align-items-center ${className}`}
      >
        <div className="loading-animation z-3">
          <section className="dots-container">
            <div className="dot"></div>
            <div className="dot"></div>
            <div className="dot"></div>
            <div className="dot"></div>
            <div className="dot"></div>
          </section>
        </div>
      </Element>
    );
  }

  return children;
};

export default LoadAndDisplay;
